<template>
	<card layout="grid" tag="section">
		<template #default>
			<div class="image-list">
				<user-picture
					v-for="(u, index) in list"
					reactive
					link
					size="xlarge"
					:user="u"
					:key="index"></user-picture>
				<loading v-if="loading"></loading>
			</div>
		</template>
	</card>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";

	export default {
		props: {
			adgroup: {
				type: String,
				default: undefined
			},
			take: {
				type: [Number, String],
				default: 8
			},
			sort: {
				type: String,
				default: "lastName"
			},
			sortDirection: {
				type: String,
				default: "ASC"
			},
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		setup(props, context) {
			const $json = inject("$json");
			const moment = inject("$moment");
			const $http = inject("$http");

			const loading = ref(true);
			const list = ref([]);

			const GetMemberList = async () => {
				loading.value = true;

				try {
					const response = await $http.post("/api/v2/widget/memberListPromo", {
						filter: props.filters?.keys || [],
						take: props.take || undefined,
						sort: props.sort,
						sortDirection: props.sortDirection,
						adgroup: props.adgroup
					});
					list.value = response.data;
				} catch (err) {
					console.error(err);
				}

				loading.value = false;
			};

			onMounted(() => {
				GetMemberList();
			});

			return {
				moment,
				loading,
				list
			};
		}
	};
</script>

<style scoped>
	.image-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		gap: 1em;
	}
</style>
